export * from './baImageLoader.service';



// WEBPACK FOOTER //
// /Desenvolvimento/PMP/painel/src/app/theme/services/baImageLoader/index.ts